export const img_url=process.env.REACT_APP_BACKEND_SERVICE+"/media/";
export const articles_url=process.env.REACT_APP_BACKEND_SERVICE+"/articles/";
